import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  // Tiene traccia di quante direttive appShowLoading sono attive
  private activeDirectives = signal(0);

  // Un segnale che forzerà la chiusura indipendentemente dal conteggio
  private forceStopTrigger = signal(0);

  // Esponiamo uno stato computato
  readonly mustHide = computed(() => this.forceStopTrigger());

  register() {
    this.activeDirectives.update(v => v + 1);
  }

  deregister() {
    this.activeDirectives.update(v => Math.max(0, v - 1));
  }

  // Chiamato dal WebService in caso di errore
  forceStopAll() {
    this.activeDirectives.set(0); // Reset contatore
    this.forceStopTrigger.update(v => v + 1); // Notifica alle direttive
  }
}